module.exports = __webpack_public_path__ + "media/dice-roll.5bfa1c3b.wav";